/**
 * Created by Ning Jiang on 10/26/2018.
 */

import {ParticleConfigs} from "../particles/ParticleConfigs";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

require("pixi-particles");

export class BigWinCoinsFountain extends BaseView {

    private readonly _screenHeightRange: [number, number] = [720, 1760];
    private readonly _startSpeedRange: [number, number] = [750, 1150];
    private readonly _particleMaxLife:number = 2;

    private readonly _coinsConfigs: any[] = [
        ParticleConfigs.bigWinLevel01,
        ParticleConfigs.bigWinLevel02,
        ParticleConfigs.bigWinLevel03,
        ParticleConfigs.bigWinSparkle,
        ParticleConfigs.bigWinLevel04
    ];

    private _coinsEmitters: Emitter[];
    private _container: PIXI.Container;
    private _emitterLayers: PIXI.Container[];

    private _isPlaying: boolean = false;

    constructor(container: PIXI.Container) {
        super();
        this._container = container;
        this._emitterLayers = [];
    }

    protected initAnimations(): void {
        this._coinsEmitters = [];
        this._coinsConfigs.forEach((config: any, level: number) => {
            const emitterContainer: PIXI.Container = new PIXI.Container();
            this._container.addChild(emitterContainer);
            const emitter: Emitter = new Emitter(emitterContainer, [{
                framerate: 30,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures(`bigWinCoin${level}`)
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmitters.push(emitter);
        });
    }

    public startFountain(playLevel: number): void {
        if (this._isPlaying == false) {
            this._isPlaying = true;
            //Always play sparkles
            this._coinsEmitters[this._coinsEmitters.length - 2].emit = true;
        }

        if (this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        this._coinsEmitters.forEach((emitter: Emitter, level: number) => {
            if (level <= playLevel) {
                emitter.emit = true;
            }
        });
    }

    public stopFountain(): void {
        this._isPlaying = false;
        this._coinsEmitters.forEach((emitter: Emitter) => {
            emitter.emit = false;
        })
    }

    protected onResize(resizeData: IResizeData): void {
        this._resizeData = resizeData;

        if (!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;

        let screenHeight = Math.max(this._screenHeightRange[0], Math.min(resizeData.height, this._screenHeightRange[1]));
        const startSpeed: number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
        const y: number = (resizeData.height - ((resizeData.height - 720) / 2)) + 30;
        this._coinsEmitters.forEach((emitter: Emitter, level: number) => {
            const levelSpeed: number = startSpeed * (1 + 0.05 * level);
            emitter.cleanup();
            emitter.startSpeed.value = levelSpeed;
            emitter.spawnPos.y = y;
            emitter.maxLifetime = MathHelper.ceilToDecimals(this._particleMaxLife * (resizeData.height/720), 2);
        });
    }
}